module.exports = __webpack_public_path__ + "img/header-search.6af478e0.png";